import { ApiService } from '../../services/api_service';
import * as classNames from 'classnames';
import { ContextService } from '../../services/context_service';
import { DataService } from '../../services/data_service';
import DialogWrapper2 from '../dialog/dialog_wrapper_v2';
import { i18n } from '../../i18n/i18n';
import { IDs } from '../../helpers/IDs';
import { lazyInject } from '../../services/inversify';
import { OnlineHilfe } from '../helpSystem/OnlineHilfe';
import * as React from 'react';
import ReactTooltip from 'react-tooltip';
import style from './buttons.less';
import { WArchivIcon } from './WArchivIcon';

interface WHelpIconProps extends React.ClassAttributes<any> {
    theme?: string;
    label: string;
    helpKey: string;
    helpDatei?: string;
    type: string;
    data: any;
    disabled?: boolean;
    customElement?: string | JSX.Element;
    style?: string;
    styleDivProps?: React.CSSProperties;
    styleProps?: React.CSSProperties;
    editBar?: boolean;
    isMultilingual?: boolean;
    directEdit?: boolean;
    enableMouseOver?: boolean;
    helpInVisible?: boolean;
    useTheme?: number | boolean;
    useWhite?: boolean;
    containerId?: string; // for OlineHilfe -> Dialog
    additionalWrapperClass?: string;
}

interface WHelpIconState extends React.ClassAttributes<any> {
    showHelp: boolean;
    mouseOvered: boolean;
    mousePos: any;
    helpIsVorhanden: boolean;
    renderTooltip: boolean;
    isAuto: boolean;
}

export class WHelpIcon extends React.Component<WHelpIconProps, WHelpIconState> {

    public static loadCache: any = {};
    public static loadObserver: any = {};

    constructor(props: any) {
        super(props);
        this.state = {
            showHelp: false,
            mouseOvered: false,
            mousePos: {},
            helpIsVorhanden: false,
            renderTooltip: true,
            isAuto: false
        };
        this.tooltip_id = `tooltip_${props.helpKey}_${Date.now()}`;
        this.updateMouseOver = this.updateMouseOver.bind(this);
        this.isVorhanden = this.isVorhanden.bind(this);
    }

    private static currentlyShowing: any = {};
    private currentHelpId = new Date().getTime() + '_' + Math.random();
    private tooltip_id: string = null;
    private unmounted = false;
    private debug = false;

    @lazyInject(ApiService) private apiService: ApiService;
    @lazyInject(ContextService) private contextService: ContextService;
    @lazyInject(DataService) private dataService: DataService;

    componentDidMount() {
        this.loadData();
    }

    componentWillUnmount() {
        this.unmounted = true;
    }

    getTheme(): string[] {
        const { useTheme, useWhite } = this.props;
        if (useTheme === undefined || useTheme === false) {
            return []; // Hier auskommentieren -> global aktiv
        }

        let tabIdxStartTabsHeader: number;
        if (typeof useTheme === "number") {
            tabIdxStartTabsHeader = useTheme;
        } else {
            const contextVal = this.contextService?.get('tabIdxStartTabsHeader');
            tabIdxStartTabsHeader = contextVal !== undefined ? +contextVal : 0;
        }

        let theme: string[] = [];
        switch (tabIdxStartTabsHeader) {
            case 0:
                theme = ['infoButtonThemeSmallBlue', useWhite ? 'theme_info_white' : 'theme_info_blue'];
                break;
            case 1:
                theme = ['infoButtonThemeSmallGreen', useWhite ? 'theme_info_white' : 'theme_info_green'];
                break;
            case 2:
                theme = ['infoButtonThemeSmallOrange', useWhite ? 'theme_info_white' : 'theme_info_orange'];
                break;
            case 3:
            //     theme = ['infoButtonThemeSmallOrange', useWhite ? 'theme_info_white' : 'theme_info_orange'];
            //     break;
            // case 4:
                theme = ['infoButtonThemeSmallGrey', useWhite ? 'theme_info_white' : 'theme_info_grey'];
                break;
            default:
                return [];
        }
        switch (this.props.style) {
            case 'theme_tab0':
                theme = ['infoButtonThemeSmallBlue', useWhite ? 'theme_info_white' : 'theme_info_blue'];
                break;
            case 'theme_tab1':
                theme = ['infoButtonThemeSmallGreen', useWhite ? 'theme_info_white' : 'theme_info_green'];
                break;
            case 'theme_tab2':
                theme = ['infoButtonThemeSmallOrange', useWhite ? 'theme_info_white' : 'theme_info_orange'];
                break;
            case 'theme_tab3':
                theme = ['infoButtonThemeSmallGrey', useWhite ? 'theme_info_white' : 'theme_info_grey'];
                break;
        }
        return theme.map((name: string) => style[name]);
    }

    loadData() {
        // Wenn im Cache nur "true" steht, dann lädt die Hilfe noch
        // damit trägt sich das nächst Icon in die "Observer"-Liste ein und wird mitversorgt
        // sobald das 1. Icon die Daten geladen hat.
        if (WHelpIcon.loadCache[this.props.helpKey]) {
            if (WHelpIcon.loadCache[this.props.helpKey] === true) { // Es wird bereits geladen
                if (!WHelpIcon.loadObserver[this.props.helpKey]) {
                    WHelpIcon.loadObserver[this.props.helpKey] = [];
                }
                WHelpIcon.loadObserver[this.props.helpKey].push(this.isVorhanden);
                if (this.debug) {
                    console.log('Waiting for Help: ' + this.props.helpKey);
                }

            } else {
                // Daten sind da, direkt verwenden
                this.isVorhanden(WHelpIcon.loadCache[this.props.helpKey]);
                if (this.debug) {
                    console.log('Reusing Help: ' + this.props.helpKey);
                }
            }
        } else {
            // Daten müssen geladen werden
            WHelpIcon.loadCache[this.props.helpKey] = true; // Markieren, dass wir laden!
            this.dataService.loadData(IDs.ENT_ONLINE_HILFE, { modul: this.props.helpKey }, {}, (data: any) => {
                this.isVorhanden(data);
                if (WHelpIcon.loadObserver[this.props.helpKey]) {
                    if (this.debug) {
                        console.log('Resolve Help Observer: ' + this.props.helpKey + ' -> ' + WHelpIcon.loadObserver[this.props.helpKey].length);
                    }
                    WHelpIcon.loadObserver[this.props.helpKey].forEach((iv: (data: any) => void) => iv(data));
                    delete (WHelpIcon.loadObserver[this.props.helpKey]);
                }
            }, IDs.MOD_ETOOL_ADMIN);
            if (this.debug) {
                console.log('Loading Help: ' + this.props.helpKey);
            }
        }
    }

    isVorhanden(data: any) {
        if (!WHelpIcon.loadCache[this.props.helpKey]) {
            WHelpIcon.loadCache[this.props.helpKey] = data;
        }
        if (this.unmounted) {
            return;
        }
        const helpIsVorhanden = data && Array.isArray(data.online_hilfe) && data.online_hilfe.length > 0 ? true : false;
        const renderTooltip = !this.props.enableMouseOver || (this.props.enableMouseOver && !helpIsVorhanden) ? false : true;
        let showHelp = false;
        // const isAuto = data.online_hilfe[0].auto_open === 1;
        const isAuto = data && Array.isArray(data.online_hilfe) && data.online_hilfe.length > 0
            ? data.online_hilfe[0].auto_open === 1 : false;
        if (Array.isArray(data.online_hilfe) && data.online_hilfe.length > 0) {
            if (data.online_hilfe[0].auto_open === 1) {
                const userName = this.apiService.getUsername();
                const arrBlock = this.props.data['popup_block'];
                const blockItem = arrBlock && arrBlock.find((item: any) => item.user === userName && item.id === this.props.helpKey);
                const blockPopup = blockItem && blockItem.blocked === 1;
                showHelp = !blockPopup;
            }
        }
        if (showHelp && isAuto) {
            const lastKey: string = this.contextService.get('WHelpIconLastAutoKey') || null;
            if (this.props.helpKey !== lastKey) {
                this.contextService.set('WHelpIconLastAutoKey', this.props.helpKey);
                // POPUPS BEI ONCHANGE (CHECKBOX) VERHINDERN {DateneingabeCO2Scope3Auswahl}
            } else if (this.props.helpKey === lastKey && this.props.helpKey === 'pageScope3Daten') {
                showHelp = false;
            }
        }
        this.setState({ helpIsVorhanden, renderTooltip, showHelp, isAuto });
    }

    render() {
        let caseStyle = 'small';
        switch (this.props.style) {
            case 'small': {
                caseStyle = style.actionButtonSmall;
                break;
            }
            case 'big': {
                caseStyle = style.actionButtonBig;
                break;
            }
            case 'theme_small': {
                caseStyle = style.actionButtonThemeSmall;
                break;
            }
            case 'theme': {
                caseStyle = style.actionButtonTheme;
                break;
            }
            case 'theme_tab1': {
                caseStyle = style.actionButtonThemeTab1;
                break;
            }
            default: {
                caseStyle = style.actionButton;
                break;
            }
        }
        const { disabled, helpKey, styleProps, type, helpInVisible, enableMouseOver } = this.props;
        const { helpIsVorhanden } = this.state;
        // const enableMouseOver = true || this.props.enableMouseOver;

        if (helpInVisible && !helpIsVorhanden) {
            return (<div></div>);
        } else {
            if (this.state.showHelp) {
                if (!WHelpIcon.currentlyShowing[helpKey]) {
                    WHelpIcon.currentlyShowing[helpKey] = this.currentHelpId;
                } else if (WHelpIcon.currentlyShowing[helpKey] !== this.currentHelpId) {
                    return <div />;
                }
            } else {
                if (WHelpIcon.currentlyShowing[helpKey] === this.currentHelpId) {
                    WHelpIcon.currentlyShowing[helpKey] = null;
                }
            }

            let customElement: any = this.props.customElement;
            if (this.props.type === 'theme_info' && typeof customElement === 'string') {
                customElement = (
                    <div
                        style={{
                            fontSize: 11, fontStyle: 'normal', fontWeight: 'normal', textDecoration: 'underline', marginTop: -4,
                            marginLeft: 1,/* marginLeft: 15, borderBottom: '1px solid'*/
                        }}
                    >
                        {customElement}
                    </div>
                );
            }

            const hilfeData = ((this.props.data || {})[IDs.ENT_ONLINE_HILFE] || []).find((r: any) => r.modul === helpKey);
            const dataTip: string = hilfeData ?
                hilfeData.info ? hilfeData.info
                    : `${hilfeData.name} (${i18n('keine Kurzinfo vorhanden', 'sys')})`
                : '';

            return (
                <div style={this.props.styleDivProps} className={this.props.additionalWrapperClass || null}>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <button
                            className={this.props.style !== 'custom' ? classNames(caseStyle, style[type], ...this.getTheme()) : ''}
                            style={styleProps ? styleProps : undefined}
                            onClick={(event: any) => { event.stopPropagation(); }}
                            disabled={disabled}
                            onMouseUp={() => this.setState({ showHelp: true, mouseOvered: false })}
                            onMouseEnter={enableMouseOver && helpIsVorhanden
                                ? (event: any) => {
                                    const left = event.target.getBoundingClientRect().left;
                                    const top = event.target.getBoundingClientRect().top;
                                    this.setState({
                                        mouseOvered: true,
                                        mousePos: { top, left }
                                    });
                                }
                                : null
                            }
                            onMouseLeave={enableMouseOver && helpIsVorhanden ? () => this.setState({ mouseOvered: false }) : null}
                            data-tip={dataTip}
                            data-for={this.tooltip_id}
                        />
                        {customElement || null}
                    </div>
                    {this.state.showHelp && !this.state.mouseOvered &&
                        <React.Fragment>
                            {this.props.helpDatei
                                ? <React.Fragment>{this.renderDatei()}</React.Fragment>
                                : <OnlineHilfe
                                    data={this.props.data}
                                    helpKey={helpKey}
                                    closeHelp={() => this.setState({ showHelp: false })}
                                    editBar={this.props.editBar}
                                    type={this.props.type}
                                    enableMouseOver={this.props.enableMouseOver}
                                    updateMouseOver={this.props.enableMouseOver ? this.updateMouseOver : null}
                                    forcedPopup={this.state.isAuto}
                                    directEdit={this.props.directEdit}
                                    isMultilingual={this.props.isMultilingual}
                                    containerId={this.props.containerId}
                                />
                            }
                        </React.Fragment>
                    }
                    {!this.state.showHelp && this.state.mouseOvered &&
                        <OnlineHilfe
                            data={this.props.data}
                            helpKey={helpKey}
                            closeHelp={() => this.setState({ mouseOvered: false })}
                            editBar={this.props.editBar}
                            type={this.props.type}
                            showMouseOver={this.state.mouseOvered ? true : false}
                            mousePos={this.state.mousePos}
                            forcedPopup={this.state.isAuto}
                            containerId={this.props.containerId}
                        />
                    }
                    <ReactTooltip
                        className={style.reactTooltip}
                        id={this.tooltip_id}
                        place={'top'}
                        type='info'
                        effect='solid'
                    />
                </div>
            );
        }
    }

    renderDatei() {
        const id: number = ((this.props.data[IDs.ENT_DATEIEN] || [])
            .find((item: any) => (item.kennung || null) === this.props.helpDatei) || {}).datei || null;
        return (
            <div style={{ display: 'inline-block' }}>
                <DialogWrapper2
                    width={840}
                    onAfterClose={() => this.setState({ showHelp: false })}
                    containerId={this.props.containerId}
                >
                    <WArchivIcon
                        module={IDs.MOD_ETOOL_ADMIN}
                        archivId={id}
                        hideIcon
                        hideFilename
                        inlineMode={true}
                        title={<span style={{ color: '#6692c3', cursor: 'pointer' }}>iBEF-Hilfe</span>}
                        iconSize={24}
                    />
                </DialogWrapper2>
            </div>
        );
    }

    updateMouseOver() {
        const renderTooltip = !this.state.renderTooltip;
        this.setState({ renderTooltip });
        this.loadData();
    }
}
